import { Injectable, Signal, signal } from '@angular/core';

import { UserProfile } from './user.abstraction';

@Injectable({
  providedIn: 'root',
})
export class UserStorageService {
  private readonly profile = signal<UserProfile | null>(null);

  getProfileSignal(): Signal<UserProfile | null> {
    return this.profile.asReadonly();
  }

  setProfile(profile: UserProfile) {
    this.profile.set(profile);
  }
}
